import { Page } from '@/core/architecture'

import { ArtistMembershipTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ArtistMembership Page
 * Implemented as a practical sample.
 */
export const ArtistMembership: Page = () => {
  const { state, actions } = useViewModel()

  return <ArtistMembershipTemplate state={state} {...actions} />
}
